import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {ELink, EUndecoratedButton} from 'webapp-lib/Components';
import {mixinFocusWithBeforeContent, mixinSVGIcon} from 'webapp-lib/styling';

const mixinBaseNavItem = css`
  display: flex;
  align-items: center;
  position: relative;
  padding: var(--gutter-little) var(--gutter-small);
  font-size: var(--font-size-default);

  &.active {
    font-weight: var(--subnav-active-tab-font-weight);
    color: var(--color-core-black);
    background-color: var(--color-state-active);
  }

  &:hover:not(:disabled) {
    background-color: var(--color-state-hover);
    color: var(--color-core-black);
  }

  &:focus {
    ${mixinFocusWithBeforeContent}
  }
`;

export const SubNavLink = styled(ELink)`
  ${mixinBaseNavItem}
  font-weight: var(--font-weight-thin);
  text-decoration: none;
`;

export const SubNavButton = styled(EUndecoratedButton)`
  ${mixinBaseNavItem}
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-left: var(--gutter-tiny);

  > svg {
    ${mixinSVGIcon}
  }
`;
